"use client";

import { useEffect } from "react";
import { useAuthStore } from "@/lib/store/auth-store";
import { useInterestsStore } from "@/lib/store/interests-store";
import { fetchMyInterestedSlugs } from "@/lib/api";

export function InterestsHydrator() {
  const user = useAuthStore((state) => state.user);
  const setAll = useInterestsStore((state) => state.setAll);
  const clear = useInterestsStore((state) => state.clear);

  useEffect(() => {
    if (!user) {
      clear();
      return;
    }
    fetchMyInterestedSlugs()
      .then(setAll)
      .catch(() => {});
  }, [user, setAll, clear]);

  return null;
}
